import * as actionTypes from "../constants/actionTypes";
import * as handlers from "../constants/handlers";
import * as barcodeService from "./responseService/barcodeService";
import * as colorStatsService from "./responseService/colorStatsService";
import * as currencyService from "./responseService/currencyService";
import * as customerService from "./responseService/customerService";
import * as customFormulaService from "./responseService/customFormulaService";
import * as dispensingHistoryService from "./responseService/dispensingHistoryService";
import * as dispensingService from "./responseService/dispensingService";
import * as favoriteService from "./responseService/favoriteService";
import * as fileTransferService from "./responseService/fileTransferService";
import * as filteringService from "./responseService/filteringService";
import * as formulaDataService from "./responseService/formulaDataService";
import * as gammaService from "./responseService/gammaService";
import * as globalDataService from "./responseService/globalDataService";
import * as imageService from "./responseService/imageService";
import * as importExportService from "./responseService/importExportService";
import * as initDataService from "./responseService/initDataService";
import * as initService from "./responseService/initService";
import * as licenseService from "./responseService/licenseService";
import * as loginService from "./responseService/loginService";
import * as marginService from "./responseService/marginService";
import * as matchingService from "./responseService/matchingService";
import * as orderingService from "./responseService/orderingService";
import * as partialUpdatesService from "./responseService/partialUpdatesService";
import * as pricingService from "./responseService/pricingService";
import * as qualityControlService from "./responseService/qualityControlService";
import * as searchPanelService from "./responseService/searchPanelService";
import * as serverService from "./responseService/serverService";
import * as settingsService from "./responseService/settingsService";
import * as spectroService from "./responseService/spectroService";
import * as ticketingService from "./responseService/ticketingService";
import * as userService from "./responseService/userService";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.GET_PRODUCTS_BY_PARAMS:
        case handlers.GET_PRODUCTS_WITH_AUTOSELECT:
        case handlers.GET_FANDECKS_BY_PARAMS:
        case handlers.GET_FANDECKS_WITH_AUTOSELECT:
        case handlers.GET_FANDECKS_WITH_OFFSET:
        case handlers.GET_COLORS_BY_PARAMS_INIT:
        case handlers.GET_COLORS_BY_PARAMS:
        case handlers.GET_COLORS_WITH_AUTOSELECT:
        case handlers.GET_COLORS_WITH_OFFSET:
        case handlers.GET_COLOR_CODES_BY_PARAMS_INIT:
        case handlers.GET_COLOR_CODES_BY_PARAMS:
        case handlers.GET_COLOR_CODES_WITH_OFFSET:
        case handlers.GET_BASES_BY_PARAMS:
        case handlers.GET_BASES_WITH_OFFSET:
        case handlers.GET_BASES_WITH_AUTOSELECT:
        case handlers.GET_BIPP_BY_PARAMS:
        case handlers.GET_BIPP_WITH_OFFSET:
        case handlers.GET_BIPP_WITH_AUTOSELECT:
        case handlers.BROWSE_CIF:
        case handlers.BROWSE_CIF_WITH_OFFSET:
            return searchPanelService.processWebsocketResponse(tabId, method, response, state);
        case handlers.GET_CALCULATED_FORMULA:
        case handlers.SEARCH_PANEL_GET_CALCULATED_FORMULA:
        case handlers.NAVIGATION_GET_CALCULATED_FORMULA:
        case handlers.GET_CALCULATED_FORMULA_FOR_COLOR_SEARCH:
        case handlers.RECALCULATE_FORMULA:
        case handlers.RECALCULATE_MODIFIED_FORMULA:
        case handlers.INTERGAMMA_RECALCULATE_FORMULA:
        case handlers.GET_AVAILABLE_FORMULAS:
        case handlers.GET_FORMULA_META_AND_PRINT_DATA:
        case handlers.GET_FORMULA_META_AND_PRINT_DATA_WITH_UFI:
        case handlers.NAVIGATION_GET_FORMULA_META_AND_PRINT_DATA:
        case handlers.GENERATE_FANDECK_PREVIEW:
        case handlers.GET_ALL_COLORANTS_FOR_BIP:
        case handlers.GET_FORMULA_CIF:
        case handlers.GET_FORMULA_CIF_DATA:
        case handlers.GET_CLOSEST_COLOR:
        case handlers.GET_CLOSEST_COLOR_WITH_PRICES:
        case handlers.RELOAD_CLOSEST_COLOR_WITH_PRICES:
        case handlers.GET_CLOSEST_COLOR_FOR_MISSING_FORMULA:
        case handlers.GET_BUILDING_SITES:
        case handlers.GET_BUILDING_SITES_WITH_OFFSET:
        case handlers.GET_FORMULA_VALIDATION_ERRORS:
        case handlers.GET_COLOR_IN_FANDECK:
            return formulaDataService.processWebsocketResponse(tabId, method, response, state);
        case handlers.ADD_COLOR_STATS:
        case handlers.ADD_COLOR_STATS_CORRECTION:
        case handlers.ADD_COLOR_STATS_FROM_ORDER:
        case handlers.ADD_COLOR_STATS_FROM_STATS:
        case handlers.ADD_COLOR_STATS_DIRECTLY:
        case handlers.ADD_COLOR_STATS_FROM_ORDER_DIRECTLY:
        case handlers.ADD_QUICK_TINT_INTO_STATISTICS:
        case handlers.ADD_QUICK_TINT_STATS_DIRECTLY:
            return colorStatsService.processWebsocketResponse(tabId, method, response, state);
        case handlers.GET_FORMULA_META_AND_DISPENSE:
        case handlers.ADD_DISPENSED_PACKAGE:
        case handlers.FINISH_DISPENSED_PACKAGE:
        case handlers.ADD_AND_FINISH_ALL_DISPENSED_PACKAGE:
        case handlers.GET_PACKAGES_FOR_COLORANT:
        case handlers.GET_PACKAGES_FOR_COLORANT_WITH_IMAGE:
        case handlers.GET_BATCHES_BY_COLORANT:
        case handlers.GET_ALL_COLORANT_BATCHES:
            return dispensingService.processWebsocketResponse(tabId, method, response, state);
        case handlers.SEARCH_GLOBAL_FORMULAS:
        case handlers.SEARCH_GLOBAL_FORMULAS_WITH_OFFSET:
        case handlers.RELOAD_ALL_COLORANTS:
        case handlers.RELOAD_ALL_SERVER_COLORANTS:
        case handlers.RELOAD_LAST_DISPENSED_FORMULAS:
        case handlers.ENABLE_PRODUCT:
        case handlers.RELOAD_GLOBAL_ALL_PRODUCTS:
        case handlers.RELOAD_GLOBAL_ALL_PRODUCTS_SIMPLE:
        case handlers.GET_DISABLED_PRODUCTS_STATUS:
        case handlers.ENABLE_FANDECK:
        case handlers.RELOAD_GLOBAL_ALL_FANDECKS:
        case handlers.GET_DISABLED_FANDECKS_STATUS:
        case handlers.GET_ALL_TINTOMETRIC_SYSTEMS:
        case handlers.GET_ACTIVE_TINTOMETRIC_SYSTEM:
        case handlers.GET_TINTOMETRIC_SYSTEM_ICON:
        case handlers.RELOAD_GLOBAL_INITIAL_DATA:
        case handlers.RELOAD_GLOBAL_PRICE_SETTINGS:
        case handlers.RELOAD_GLOBAL_GET_ALL_UNITS:
            return globalDataService.processWebsocketResponse(tabId, method, response, state);
        case handlers.INIT:
        case handlers.GET_ALL_DATABASES_LIST:
        case handlers.GET_ALL_DATABASES_LIST_AND_SKIP_UPDATE:
        case handlers.GET_SERVER_VERSION:
        case handlers.GET_ACTIVE_DATABASE:
            return initService.processWebsocketResponse(tabId, method, response);
        case handlers.INIT_GLOBAL_LAST_DISPENSED_FORMULAS:
        case handlers.INIT_GLOBAL_FAVORITE_FORMULAS:
        case handlers.INIT_GLOBAL_COLORANTS:
        case handlers.INIT_GLOBAL_ALL_PRODUCTS:
        case handlers.INIT_GLOBAL_ALL_PRODUCTS_SIMPLE:
        case handlers.INIT_GLOBAL_ALL_FANDECKS:
        case handlers.INIT_GLOBAL_MARGINS:
        case handlers.INIT_GLOBAL_DATABASES_LIST:
        case handlers.INIT_GLOBAL_COMPATIBLE_SERVERS:
        case handlers.INIT_GLOBAL_SETTING_OPTIONS:
        case handlers.INIT_GLOBAL_INITIAL_DATA:
        case handlers.INIT_GLOBAL_USER_SETTINGS:
        case handlers.INIT_GLOBAL_PRICE_SETTINGS:
        case handlers.INIT_GLOBAL_SERVER_CONFIGURATION:
        case handlers.INIT_GLOBAL_ALL_SERVER_COLORANTS:
        case handlers.INIT_GLOBAL_TO_DISPENSE_GET_ORDERS:
        case handlers.INIT_GLOBAL_GET_ALL_UNITS:
            return initDataService.processWebsocketResponse(tabId, method, response, state).concat([
                {
                    type: actionTypes.INCREASE_LOADING
                }
            ]);
        case handlers.GET_LICENSE_STATUS:
        case handlers.GET_LICENSE_STATUS_COMPACT:
        case handlers.GET_LICENSE_INFO:
        case handlers.ONLINE_ACTIVATION_AVAILABLE_FOR_LICENSE_WIZARD:
        case handlers.ONLINE_LICENSE_ACTIVATION_AVAILABLE:
        case handlers.ONLINE_LICENSE_UPDATE:
        case handlers.GET_LICENSE_REQUEST:
        case handlers.GET_AVAILABLE_LICENSE_PRODUCTS_ORDERED:
        case handlers.GET_AVAILABLE_LICENSE_PRODUCTS:
        case handlers.ONLINE_LICENSE_COUNTS:
        case handlers.ONLINE_LICENSE_ACTIVATE:
        case handlers.CREATE_LICENSE_REQUEST:
        case handlers.REMOVE_LICENSE_REQUEST:
        case handlers.INSTALL_LICENSE:
        case handlers.GET_REGISTRATION_DATA:
        case handlers.SET_REGISTRATION_DATA:
        case handlers.GET_POS_INFO:
            return licenseService.processWebsocketResponse(tabId, method, response, state);
        case handlers.GET_DATABASES_LIST:
        case handlers.GET_DATABASES_READY_FOR_PARTIAL_UPDATES:
        case handlers.SET_ACTIVE_DATABASE:
        case handlers.GET_COMPATIBLE_SERVERS:
        case handlers.GET_COMPATIBLE_SERVERS_AND_OPEN_MODAL:
        case handlers.LIGHT_LOAD_COMPATIBLE_SERVERS:
        case handlers.UPDATE_DATABASES:
        case handlers.ADD_SERVER:
        case handlers.EDIT_SERVER:
        case handlers.DELETE_REDLIKE_SERVERS:
        case handlers.GET_SERVER_MANAGEMENT_LIST:
        case handlers.INSTALL_DATABASE_FILE_EXCEL:
        case handlers.INSTALL_DATABASE_FILE_EXE:
        case handlers.INSTALL_DATABASE_FILE_ZIP:
        case handlers.SET_CLIENT_IDENTIFIER:
        case handlers.GET_CLIENT_IDENTIFIER:
        case handlers.UNLOCK_COMPUTER:
            return serverService.processWebsocketResponse(tabId, method, response, state);
        case handlers.GET_LOGGED_USER:
        case handlers.GET_LOGGED_DATABASE_USER:
        case handlers.LOG_IN:
        case handlers.LOG_OUT:
        case handlers.VALIDATE_USER_PASSWORD:
        case handlers.VALIDATE_USER_PASSWORD_AUTHENTICATION:
        case handlers.LOG_IN_AND_CHANGE_USER:
        case handlers.LOG_OUT_AND_CHANGE_USER:
        case handlers.GET_ALL_USERS_AND_AUTOLOGIN:
        case handlers.LOG_OUT_AND_AUTOLOGIN_USER:
        case handlers.GET_ACTIVE_DATABASE_AND_LOG_IN:
            return loginService.processWebsocketResponse(tabId, method, response, state);
        case handlers.GET_FORMULA_NOTE_IMAGE:
        case handlers.GET_COLORANT_PACKAGE_IMAGE:
        case handlers.GET_DATABASE_IMAGE:
        case handlers.GET_COLOR_IMAGE:
        case handlers.GET_PRODUCT_IMAGE:
        case handlers.GET_DISPENSING_PRODUCT_IMAGE:
        case handlers.INTERGAMMA_MACHINE_GET_PRODUCT_IMAGE:
        case handlers.GET_LIGHT_TO_DISPENSE_PRODUCT_IMAGE:
        case handlers.GET_LIGHT_MY_ORDERS_PRODUCT_IMAGE:
        case handlers.GET_ALL_BANNERS:
        case handlers.GET_BANNER_IMAGE:
        case handlers.GET_BARCODE_TEST_MODAL_PRODUCT_IMAGE:
        case handlers.GET_BARCODE_TEST_MODAL_COLORANT_PACKAGE_IMAGE:
        case handlers.INIT_FILE_PREVIEW:
        case handlers.GET_FILE_PAGE_PREVIEW:
        case handlers.GET_FILE_AND_EXPORT:
            return imageService.processWebsocketResponse(tabId, method, response, state);
        case handlers.FILTERING_GET_DEFAULT_PRODUCT_LIST:
        case handlers.FILTERING_GET_DEFAULT_FANDECK_LIST:
        case handlers.FILTERING_GET_LOCAL_FANDECK_LIST:
        case handlers.FILTERING_GET_DEFAULT_FORMULA_LIST:
        case handlers.FILTERING_GET_LOCAL_FORMULA_LIST:
        case handlers.FILTERING_GET_DEFAULT_FORMULA_CODE_LIST:
        case handlers.FILTERING_GET_LOCAL_FORMULA_CODE_LIST:
        case handlers.FILTERING_GET_DEFAULT_BASE_LIST:
        case handlers.FILTERING_GET_DEFAULT_PACKAGE_LIST:
        case handlers.FILTERING_GET_DEFAULT_CUSTOMER_LIST:
            return filteringService.processWebsocketResponse(tabId, method, response, state);
        case handlers.MATCHING_INIT:
        case handlers.MATCHING_CAN_BE_USED:
        case handlers.MATCHING_GET_PRODUCTS_AVAILABLE_FOR_MATCHING:
        case handlers.MATCHING_GET_COLOR_FILES_FOR_PRODUCT:
        case handlers.MATCHING_GET_COLORIFILE_DETAIL:
        case handlers.MATCHING_GET_PACKAGES:
        case handlers.MATCHING_GET_RESULT:
        case handlers.CORRECTION_GET_RESULT:
        case handlers.REFORMULATION_GET_RESULT:
        case handlers.MATCHING_TAB_GET_DETAIL:
        case handlers.MATCHING_TAB_GET_FANDECK_LIST:
        case handlers.MATCHING_TAB_GET_FANDECK_LIST_WITH_OFFSET:
        case handlers.MATCHING_TAB_GET_COLOR_LIST:
        case handlers.MATCHING_TAB_GET_COLOR_LIST_WITH_OFFSET:
            return matchingService.processWebsocketResponse(tabId, method, response, state);
        case handlers.GET_DIFFERENCE_DETAIL:
        case handlers.SET_STATISTIC_COLOR_DIFFERENCE:
            return qualityControlService.processWebsocketResponse(tabId, method, response, state);
        case handlers.GET_ITEM_BY_BARCODE:
        case handlers.GET_ITEM_BY_BARCODE_TEST:
        case handlers.GET_BASE_IN_PRODUCT_PACKAGE_BARCODES:
        case handlers.VALIDATE_BASE_IN_PRODUCT_PACKAGE_BARCODE:
        case handlers.GET_FORMULA_ITEMS_BY_BARCODE:
            return barcodeService.processWebsocketResponse(tabId, method, response, state);
        case handlers.GET_ALL_FAVORITE_FORMULAS:
        case handlers.ADD_FAVORITE_FORMULA:
        case handlers.REMOVE_FAVORITE_FORMULA:
        case handlers.ADD_FAVORITE_FOLDER:
        case handlers.EDIT_FAVORITE_FOLDER:
        case handlers.MOVE_FAVORITE_FORMULA:
        case handlers.REMOVE_FAVORITE_FOLDER:
            return favoriteService.processWebsocketResponse(tabId, method, response);
        case handlers.GET_CURRENCY:
        case handlers.ADD_CURRENCY:
        case handlers.SET_CURRENCY:
        case handlers.EDIT_CURRENCY:
        case handlers.DELETE_CURRENCY:
        case handlers.GET_ALL_CURRENCIES:
            return currencyService.processWebsocketResponse(tabId, method, response, state);
        case handlers.GET_ALL_MARGINS:
        case handlers.ADD_MARGIN:
        case handlers.EDIT_MARGIN:
        case handlers.REMOVE_MARGIN:
        case handlers.MOVE_UP_MARGIN:
        case handlers.MOVE_DOWN_MARGIN:
            return marginService.processWebsocketResponse(tabId, method, response, state);
        case handlers.PRICING_SET_GENERIC_DATA:
        case handlers.PRICING_GET_GENERIC_DATA:
        case handlers.PRICING_SET_GENERIC_COLORANT_DATA:
        case handlers.PRICING_GET_GENERIC_COLORANT_DATA:
        case handlers.PRICING_SET_GENERIC_PACKAGE_DATA:
        case handlers.PRICING_GET_GENERIC_PACKAGE_DATA:
        case handlers.PRICING_SET_GENERIC_PRODUCT_DATA:
        case handlers.PRICING_GET_GENERIC_PRODUCT_DATA:
        case handlers.PRICING_SET_COLORANT_DATA:
        case handlers.PRICING_SET_COLORANT_MARGIN_DATA:
        case handlers.PRICING_GET_COLORANTS_DATA:
        case handlers.PRICING_SET_BASE_IN_PRODUCT_DATA:
        case handlers.PRICING_SET_BASE_IN_PRODUCT_MARGIN_DATA:
        case handlers.PRICING_GET_BASE_IN_PRODUCTS_DATA:
        case handlers.PRICING_SET_BASE_IN_PRODUCT_PACKAGE_DATA:
        case handlers.PRICING_SET_BASE_IN_PRODUCT_PACKAGE_MARGIN_DATA:
        case handlers.PRICING_GET_BASE_IN_PRODUCTS_AND_PACKAGES_DATA:
        case handlers.PRICING_SET_PACKAGE_DATA:
        case handlers.PRICING_GET_PACKAGES_DATA:
        case handlers.PRICING_SET_PRICE_DEFINITION:
        case handlers.PRICING_GET_PRICE_DEFINITION:
        case handlers.PRICING_SET_PRICE_UNIT_DEFINITION:
        case handlers.PRICING_GET_PRICE_UNIT_DEFINITION:
        case handlers.PRICING_SET_PRICE_GROUP_NUMBER:
        case handlers.PRICING_GET_PRICE_GROUP_NUMBER:
        case handlers.PRICING_SET_PRICE_GROUPS:
        case handlers.PRICING_GET_PRICE_GROUPS:
        case handlers.PRICING_SET_SETTING_LOCAL_PRICES:
        case handlers.PRICING_GET_SETTING_LOCAL_PRICES:
        case handlers.PRICING_SET_SETTING_MARGIN:
        case handlers.PRICING_SET_SETTING_MARKUP:
        case handlers.PRICING_SET_SETTING_DISCOUNT:
        case handlers.PRICING_GET_SETTING_MARGIN:
        case handlers.PRICING_GET_SETTING_MARKUP:
        case handlers.PRICING_GET_SETTING_DISCOUNT:
            return pricingService.processWebsocketResponse(tabId, method, response, state);
        case handlers.IMPORT_SETTINGS:
        case handlers.EXPORT_SETTINGS:
        case handlers.EXPORT_STATIC_SQL:
        case handlers.RESTORE_SETTINGS:
        case handlers.RELOAD_USER_SETTINGS:
        case handlers.EXPORT_LOCAL_DB:
        case handlers.EXPORT_LOCAL_FILE:
        case handlers.SUPPORTED_IMPORT_CUSTOM_DATA_FORMATS:
        case handlers.IMPORT_CUSTOM_DATA:
        case handlers.ABORT_CUSTOM_DATA_IMPORTING:
        case handlers.DELETE_IMPORTED_CUSTOM_DATA:
        case handlers.PRICING_IMPORT_DATA:
        case handlers.PREPARE_FILE_BACKUP_LOCAL_DB:
        case handlers.PREPARE_FILE_PRICING_DATA:
        case handlers.PREPARE_FILE_STATS_DATA:
        case handlers.PREPARE_FILE_BYTES:
        case handlers.RELEASE_PREPARED_FILE:
            return importExportService.processWebsocketResponse(tabId, method, response, state);
        case handlers.CREATE_TICKET:
        case handlers.DELETE_TICKET:
        case handlers.GET_CUSTOM_FORMULA:
        case handlers.GET_SERVICE_DEPARTMENTS:
        case handlers.GET_TICKETS:
        case handlers.GET_TMC_CONNECTION_STATUS:
        case handlers.LOAD_TICKET_FORMULA:
        case handlers.MARK_TICKET_AS_READ:
        case handlers.TICKETING_GET_BASE_LIST:
        case handlers.TICKETING_GET_COLOR_LIST:
        case handlers.TICKETING_GET_FANDECK_LIST:
        case handlers.TICKETING_GET_PRODUCT_LIST:
            return ticketingService.processWebsocketResponse(tabId, method, response, state);
        case handlers.GET_PREPARED_PARTIAL_UPDATES_COUNT_AFTER_INIT:
        case handlers.GET_PREPARED_PARTIAL_UPDATES_COUNT:
        case handlers.GET_ALL_PREPARED_UPDATES_PER_DATABASE:
        case handlers.APPLY_ALL_PREPARED_UPDATES_PER_DATABASE:
            return partialUpdatesService.processWebsocketResponse(tabId, method, response);
        case handlers.GET_CUSTOMERS_BY_PARAMS:
        case handlers.GET_CUSTOMERS_WITH_OFFSET:
        case handlers.GET_ALL_CUSTOMERS:
        case handlers.GET_LAST_CUSTOMERS:
        case handlers.GET_CUSTOMER_DETAIL:
        case handlers.CUSTOMERS_TAB_GET_DETAIL:
        case handlers.ADD_CUSTOMER:
        case handlers.LIGHT_ADD_CUSTOMER:
        case handlers.EDIT_CUSTOMER:
        case handlers.DELETE_CUSTOMER:
            return customerService.processWebsocketResponse(tabId, method, response, state);
        case handlers.ADD_USER:
        case handlers.RESTORE_USER:
        case handlers.UPDATE_USER:
        case handlers.DELETE_USER:
        case handlers.CHANGE_USER_PASSWORD:
        case handlers.GET_SELECTED_USER_GROUPS:
        case handlers.ADD_USER_INTO_GROUP:
        case handlers.REMOVE_USER_FROM_GROUP:
        case handlers.REMOVE_USER_FROM_ALL_GROUPS:
        case handlers.GET_ALL_USERS:
        case handlers.GET_ALL_USER_GROUPS:
            return userService.processWebsocketResponse(tabId, method, response, state);
        case handlers.GET_ALL_CUSTOM_FANDECKS:
        case handlers.ADD_CUSTOM_FANDECK:
        case handlers.ADD_CUSTOM_FANDECK_AND_ADD_CUSTOM_FORMULA:
        case handlers.CHECK_AND_ADD_CUSTOM_FORMULA:
        case handlers.CHECK_CUSTOM_CIF_AND_ADD_CUSTOM_FORMULA:
        case handlers.EDIT_CUSTOM_FANDECK:
        case handlers.REMOVE_CUSTOM_FANDECK:
        case handlers.CUSTOM_TAB_LOAD_BASE_LIST:
        case handlers.CUSTOM_TAB_LOAD_MASTER_PRODUCT_LIST:
        case handlers.CUSTOM_TAB_GET_PACKAGES_BY_PARAMS:
        case handlers.ADD_CUSTOM_FORMULA:
        case handlers.DELETE_CUSTOM_COLOR:
        case handlers.CHECK_AND_ADD_CUSTOM_FORMULA_FROM_XML:
        case handlers.ADD_CUSTOM_FORMULA_FROM_XML:
            return customFormulaService.processWebsocketResponse(tabId, method, response, state);
        case handlers.GET_STATISTICS:
        case handlers.GET_STATISTICS_WITH_OFFSET:
        case handlers.GET_FORMULA_DATA_FROM_STATS:
        case handlers.GET_FORMULA_META_DATA_FROM_STATS:
        case handlers.SET_STATISTIC_HIDDEN:
        case handlers.SET_STATISTIC_MORE_INFO:
        case handlers.GET_CORRECTION_HISTORY:
        case handlers.EXPORT_STATISTICS_HISTORY:
            return dispensingHistoryService.processWebsocketResponse(tabId, method, response, state);
        case handlers.ADD_ORDER_RECORD:
        case handlers.ADD_ORDER_RECORD_AND_CLOSE_MODAL:
        case handlers.TO_DISPENSE_GET_ORDERS:
        case handlers.TO_DISPENSE_GET_ORDERS_WITH_OFFSET:
        case handlers.TO_DISPENSE_GET_ORDERS_WITH_NOTIFICATION:
        case handlers.TO_DISPENSE_GET_DETAIL:
        case handlers.TO_DISPENSE_DELETE_ORDER:
        case handlers.TO_DISPENSE_SET_ORDER_STATUS_DONE:
        case handlers.SET_ORDER_MORE_INFO:
        case handlers.ASSIGN_ORDER:
        case handlers.RELEASE_ORDER:
        case handlers.MY_ORDERS_GET_DATA:
        case handlers.MY_ORDERS_GET_DATA_WITH_OFFSET:
        case handlers.MY_ORDERS_GET_DETAIL:
        case handlers.MY_ORDERS_GET_DETAIL_AND_OPEN_MODAL:
        case handlers.ORDERS_HISTORY_GET_ORDERS:
        case handlers.GET_ORDERS_HISTORY_WITH_OFFSET:
        case handlers.ORDERS_HISTORY_GET_DETAIL:
            return orderingService.processWebsocketResponse(tabId, method, response, state);
        case handlers.GET_ALL_PROTOCOLS:
        case handlers.GET_ALL_IN_FORMATS:
        case handlers.GET_ALL_OUT_FORMATS:
        case handlers.TEST_PROTOCOL:
            return fileTransferService.processWebsocketResponse(tabId, method, response);
        case handlers.GET_COLORS_BY_SPECTRO_DELTA:
            return spectroService.processWebsocketResponse(tabId, method, response);
        case handlers.INTERGAMMA_SET_ACTIVE_DATABASE:
        case handlers.INTERGAMMA_GET_ACTIVE_DATABASE:
        case handlers.INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_BARCODE:
        case handlers.INTERGAMMA_GET_ACTIVE_DATABASE_AFTER_BARCODE:
        case handlers.INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_CIF_BARCODE:
        case handlers.INTERGAMMA_GET_ACTIVE_DATABASE_AFTER_CIF_BARCODE:
        case handlers.INTERGAMMA_SET_DATABASE_AND_OPEN_FANDECK_STEP:
        case handlers.INTERGAMMA_GET_DATABASE_AND_OPEN_FANDECK_STEP:
        case handlers.INTERGAMMA_RELOAD_COLORS:
        case handlers.INTERGAMMA_RELOAD_FANDECKS:
        case handlers.INTERGAMMA_GET_PRODUCTS_BY_PARAMS:
        case handlers.INTERGAMMA_GET_ALL_CUSTOMERS:
        case handlers.INTERGAMMA_MACHINE_ORDER_DETAIL:
        case handlers.INTERGAMMA_MACHINE_ORDER_DETAIL_RELOAD:
        case handlers.INTERGAMMA_MACHINE_SET_CANCELED_ORDER_STATUS:
        case handlers.GET_CUSTOMER_BY_EMAIL:
        case handlers.INTERGAMMA_GET_DISPENSED_ORDERS_BY_CUSTOMER_ID:
        case handlers.INTERGAMMA_MACHINE_SET_ACTIVE_DATABASE:
        case handlers.INTERGAMMA_MACHINE_GET_ACTIVE_DATABASE:
        case handlers.INTERGAMMA_GET_COLORANT_PACKAGE_BY_BARCODE:
        case handlers.INTERGAMMA_GET_PRODUCT_IMAGE:
        case handlers.STOCK_ADD_COLORANT_PACKAGES:
        case handlers.STOCK_ADD_COLORANT_PACKAGES_ORDER:
        case handlers.STOCK_GET_COLORANT_PACKAGES:
        case handlers.STOCK_REMOVE_COLORANT_PACKAGE:
        case handlers.STOCK_SET_PREDICTION_FOR_COLORANT_PACKAGES:
        case handlers.GET_BARCODE:
        case handlers.GET_BARCODE_AND_OPEN_MODAL:
            return gammaService.processWebsocketResponse(tabId, method, response, state);
        default:
            if (method.startsWith("SETTINGS_")) {
                return settingsService.processWebsocketResponse(tabId, method, response, state);
            }

            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
